<template>
  <div class="text-md flex flex-col py-4">
    <div
      v-if="creditorCreatorName"
      class="mb-3 leading-5 md:text-lg md:leading-6"
    >
      {{ creditorCreatorName }}
    </div>
    <div v-if="creditorAddress" class="mb-1 leading-5 md:text-lg md:leading-6">
      {{ creditorAddress }}
    </div>
    <div v-if="creditorCityZip" class="mb-1 leading-5 md:text-lg md:leading-6">
      {{ creditorCityZip }}
    </div>
    <div v-if="creditorCountry" class="mb-3 leading-5 md:text-lg md:leading-6">
      {{ creditorCountry }}
    </div>
    <div v-if="creditorWebsite" class="mb-1 leading-5 md:text-lg md:leading-6">
      {{ creditorWebsite }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
import { getAdvancedAttributeFirstValue } from '#layers/base/utils/advancedAttribute'

const props = defineProps({
  product: {
    type: Object as PropType<Product | null>,
    default: () => null,
  },
})

const creditorCreatorName = computed(
  () =>
    getAdvancedAttributeFirstValue(props.product, 'creditorName') as
      | string
      | null
      | undefined,
)

const creditorAddress = computed(
  () =>
    getAdvancedAttributeFirstValue(props.product, 'creditorAdress') as
      | string
      | null
      | undefined,
)

const creditorCityZip = computed(() => {
  const postCode = getAdvancedAttributeFirstValue(
    props.product,
    'creditorPostCode',
  ) as string | null | undefined
  const city = getAdvancedAttributeFirstValue(props.product, 'creditorCity') as
    | string
    | null
    | undefined
  if (postCode && city) {
    return `${postCode} ${city}`
  }
  if (postCode) {
    return postCode
  }
  if (city) {
    return city
  }
  return null
})

const creditorCountry = computed(
  () =>
    getAdvancedAttributeFirstValue(props.product, 'creditorCountry') as
      | string
      | null
      | undefined,
)

const creditorWebsite = computed(() => {
  const web = getAdvancedAttributeFirstValue(props.product, 'creditorWeb') as
    | string
    | null
    | undefined
  if (!web) {
    return null
  }
  if (web.includes('@')) {
    return web
  }
  return web.startsWith('http') ? web : `https://${web}`
})
</script>
